import { createTheme } from '@mui/material/styles';

import theme from './theme';

const defaultDarkTheme = createTheme({ palette: { mode: 'dark' } });
const darkTheme = createTheme({
    ...theme,
    palette: {
        mode: 'dark',
        primary: {
            main: '#9B98B5',
            light: '#B5B3CC',
            dark: '#7D7A96',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#8B5CF6',
            light: '#A78BFA',
            dark: '#7C3AED',
            contrastText: '#ffffff',
        },
        error: {
            main: '#E86B6B',
            light: '#F39393',
            dark: '#D95555',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#FBBF24',
            light: '#FCD34D',
            dark: '#F59E0B',
            contrastText: '#000000',
        },
        info: {
            main: '#38BDF8',
            light: '#7DD3FC',
            dark: '#0EA5E9',
            contrastText: '#ffffff',
        },
        success: {
            main: '#10B981',
            light: '#34D399',
            dark: '#059669',
            contrastText: '#ffffff',
        },
        background: {
            default: '#0a0e1a',
            paper: '#1a2332',
        },
        text: {
            primary: '#e8eaed',
            secondary: '#9aa0a6',
        },
        divider: '#2d3748',
    },
    typography: theme.typography,
    components: {
        ...theme.components,
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    color: defaultDarkTheme.palette.text.primary
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${defaultDarkTheme.palette.background.default}`,
                },
                title: {
                    fontSize: '22px'
                }
            }
        },
        RaSidebar: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '& .RaSidebar-fixed': {
                        boxShadow: 'none !important'
                    },
                    '& .RaSidebar-paperAnchorLeft .RaSidebar-fixed': {
                        borderRight: `1px solid ${theme.palette.divider} !important`
                    },
                    '& .MuiMenuItem-root': {
                        borderRadius: '6px',
                        margin: '2px 8px',
                        padding: '6px 8px',
                        fontSize: '15px',
                        '& .MuiListItemIcon-root': {
                            color: 'rgba(255, 255, 255, 0.7)'
                        },
                        '&.RaMenuItemLink-active': {
                            backgroundColor: 'rgba(255, 255, 255, 0.08)',
                            color: '#FFF',
                            '& .MuiListItemIcon-root': {
                                color: '#FFF'
                            }
                        }
                    }
                })
            }
        },
    }
});

export default darkTheme;
